import React from "react";
import ResultAIAVitality from "../AddOn/AIAVitality/Cart/ResultAIAVitality";
import cx from "classnames";
import styles from "./ProviderAddons.module.scss";
import { IProviderAddon } from "../../../../compare/interfaces/IProviderAddon";
import ResultChubbLifetimeReward from "../AddOn/ChubbLifetimeReward/Cart/ResultChubbLifetimeReward";

interface IApplyAddOnsProps {
    className?: string;
    providerAddOn: IProviderAddon;
}


const ProviderAddons: React.FC<IApplyAddOnsProps> = (props) => {
    const { providerAddOn } = props;

    const getAddOns = (providerId: number): React.ReactNode[] => {
        switch (providerId) {
            case 2: //AIA
                return [<ResultAIAVitality key={"vitality"} providerAddOn={providerAddOn} />]; // We need keys in arrays.
            case 9: //Chubb Life
                return [<ResultChubbLifetimeReward key={"lifetime-reward"} providerAddOn={providerAddOn} />]; // We need keys in arrays.
            default:
                return [];
        }
    };

    const addOns = getAddOns(providerAddOn.providerId);

    if (addOns.length == 0) {
        return null;
    }

    return (
        <div
            className={cx(styles["container"], {
                [props.className]: !!props.className
            })}>
            {addOns.map((addon, index) => {
                return (
                    <div key={index} className={styles["container_row"]}>
                        {addon}
                    </div>
                );
            })}
        </div>
    );
};

export default ProviderAddons;
